// Defines which 'pages' are used and their order for the page navigation
// See also AppFlow.js
export const activePages = [
    'home',
    'module-2',
    'module-3',
    'module-4',
    'module-5_1',
    'module-5',
    'module-6',
    'module-7',
    'module-8',
    'module-9',
    'module-10',
    'module-11',
    'module-12',
    'module-13',
    'module-14',
    'module-15',
    'module-16',
    'module-17',
    'module-18',
    'module-19',
    'module-20',
    'module-21',
  ];